module.exports = require("./lib/_stream_duplex.js")



//////////////////
// WEBPACK FOOTER
// ../~/readable-stream/duplex.js
// module id = 173
// module chunks = 0